import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter, Button, Input, VStack, useToast
} from '@chakra-ui/react';
import { useState } from 'react';
import { changePassword } from '../../services/api';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const toast = useToast();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (form.newPassword !== form.confirmPassword) {
      toast({ title: 'Le nuove password non coincidono', status: 'error' });
      return;
    }

    try {
      const rawUser = localStorage.getItem('user');
      const user = rawUser && rawUser !== 'undefined' ? JSON.parse(rawUser) : null;

      if (!user?.id) {
        toast({ title: 'Utente non trovato', status: 'error' });
        return;
      }

      await changePassword(user.id, {
        old_password: form.oldPassword,
        new_password: form.newPassword,
      });

      toast({ title: 'Password aggiornata con successo', status: 'success' });
      onClose();
    } catch (err) {
      toast({
        title: 'Errore nel cambio password',
        description: err.response?.data?.message || err.message,
        status: 'error'
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cambia Password</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={3}>
            <Input
              name="oldPassword"
              type="password"
              placeholder="Vecchia password"
              value={form.oldPassword}
              onChange={handleChange}
            />
            <Input
              name="newPassword"
              type="password"
              placeholder="Nuova password"
              value={form.newPassword}
              onChange={handleChange}
            />
            <Input
              name="confirmPassword"
              type="password"
              placeholder="Conferma nuova password"
              value={form.confirmPassword}
              onChange={handleChange}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSubmit}>
            Salva
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangePasswordModal;
